import { clsx } from 'clsx';
import { forwardRef } from 'react';

import type { ButtonHTMLAttributes } from 'react';

import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  /** The value of the aria-label. */
  'aria-label': string;
  /** The variant of the button. */
  variant?: 'destructive';
  /** true if the button should be rendered without a border; otherwise, false. The default is false. */
  noBorder?: boolean;
  /** true to render the button a bit wider; otherwise, false. The default is false. */
  wide?: boolean;
}

/** Represents a component for a button with an icon. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, type = 'button', variant, noBorder, wide, ...restProps }: IconButtonProps, forwardedRef) => (
    <button
      {...restProps}
      className={clsx(styles['icon-button'], {
        [styles['icon-button--destructive']]: variant === 'destructive',
        [styles['icon-button--no-border']]: noBorder,
        [styles['icon-button--wide']]: wide,
      })}
      ref={forwardedRef}
      type={type}
    >
      {children}
    </button>
  )
);
